export const APP_THEME_KEY = 'app-theme'

export type AppThemeName = 'classic' | 'journal'

export const setAppTheme_LS = (theme: AppThemeName) => {
  localStorage.setItem(APP_THEME_KEY, theme)
}

export const getAppTheme_LS = (): AppThemeName | undefined => {
  const data = localStorage.getItem(APP_THEME_KEY)
  if (data === 'classic' || data === 'journal') return data
  return undefined
}
